import './EventImage.css';
import { Link } from 'react-router-dom';

function EventImage() {
  return (
    <div className="event-banner">
      <div className="event-overlay"></div>
      <div className="container event-content h-100 position-relative z-2">
        <div className="row h-100 align-items-center">
          <div className="col-12 col-md-8 text-center text-md-start">
            <h2 className="event-title">Santa Feira</h2>
            <div className="event-date">Todo 2º sábado do mês</div>
            <Link to="/sobre#sobre-trekking" className="btn-event mt-3">
              Descubra os detalhes
            </Link>
          </div>
          <div className="col-12 col-md-4 text-center text-md-end mt-4 mt-md-0">
            <div className="event-location">
              <i className="bi bi-geo-alt-fill me-2"></i>Santo Hilário-MG
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventImage;